import { Link } from "gatsby"

import { FastlyImage } from "@components/FastlyImage"

const PageSectionCustomers = (props) => {
  const CustomerImage = (customer) => {
    if (!customer.logo) {
      console.log(`Missing logo for ${customer.name}`)
      return null
    }

    var image
    if (!customer.name || !customer.logo) {
      return null
    }
    if (customer.caseStudy) {
      image = (
        <Link to={customer.caseStudy.url}>
          <FastlyImage alt={customer.name} src={customer.logo.file.url} params="?height=55&width=224&fit=bounds" />
        </Link>
      )
    } else {
      image = <FastlyImage alt={customer.name} src={customer.logo.file.url} params="?height=55&width=224&fit=bounds" />
    }
    return image
  }

  return (
    <div className="block-customers section">
      <div className="row">
        <div className="column text-xs-center">
          {props.content.customers.map((customer) => CustomerImage(customer))}
        </div>
      </div>
    </div>
  )
}

export default PageSectionCustomers
